import Service from './service'
import store from '../store'

export default class CommentService {
  /**
   * Permet de récupèrer toutes les remarques préformatées.
   */
  static async getComments () {
    try {
      await Service.verifyToken()
      return Service.api.get('/comment', {
        headers: Service.getAuthHeader(store.state.auth.user.token.accessToken)
      })
    } catch (error) {
      Service.handleError(error)
    }
  }
}
